/*
 *
 * BlogPostPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'blogPostPage';
export const initialState = {
    blogs: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: {
            items: [],
            category: null,
            pager: '',
        },
    },
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    params: {
        slug: '',
    },
    recommends: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: [],
    },
};

/* eslint-disable no-param-reassign, default-case */
function blogPostPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            case ActionTypes.RESET_CONTENTS:
                draft.is404 = initialState.is404;
                draft.page = initialState.page;
                draft.blogs = initialState.blogs;
                draft.recommends = initialState.recommends;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Blogs
            case ActionTypes.FETCH_BLOGS_STARTED:
                draft.blogs.isLoading = true;
                draft.blogs.isError = false;
                draft.blogs.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_BLOGS_SUCCESSFULLY:
                draft.blogs.isLoading = false;
                draft.blogs.isLoaded = true;
                draft.blogs.res = action.res;
                return draft;
            case ActionTypes.FETCH_BLOGS_FAILED:
                draft.blogs.isLoading = false;
                draft.blogs.isError = true;
                draft.blogs.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_BLOGS_CANCELLED:
                draft.blogs.isLoading = false;
                return draft;
            case ActionTypes.SET_BLOGS_IS_LOADED:
                draft.blogs.isLoaded = action.isLoaded;
                return draft;
            // Recommends
            case ActionTypes.FETCH_RECOMMENDS_STARTED:
                draft.recommends.isLoading = true;
                draft.recommends.isError = false;
                draft.recommends.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY:
                draft.recommends.isLoading = false;
                draft.recommends.isLoaded = true;
                draft.recommends.res = action.res;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_FAILED:
                draft.recommends.isLoading = false;
                draft.recommends.isError = true;
                draft.recommends.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_CANCELLED:
                draft.recommends.isLoading = false;
                return draft;
            case ActionTypes.SET_RECOMMENDS_IS_LOADED:
                draft.recommends.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default blogPostPageReducer;
